import { apiClient } from './client'

export type TrackingDiagnosticStatus = 'open' | 'acknowledged' | 'resolved'

export type TrackingDiagnosticLifecycleEvent = {
  sequence: number
  sessionId: string
  timestamp: number
  name: string
  appState?: string | null
  details: Record<string, string>
}

export type TrackingDiagnosticIncident = {
  id: string
  clientIncidentId: string
  userId: string
  sessionId: string
  indicator: string
  status: TrackingDiagnosticStatus
  detectedAt: string
  enqueuedAt: string
  receivedAt: string
  updatedAt: string
  acknowledgedAt?: string | null
  acknowledgedByUserId?: string | null
  appVersion: string
  buildNumber?: string | null
  platform: string
  appVariant: string
  context: Record<string, string>
  lifecycleEvents: TrackingDiagnosticLifecycleEvent[]
}

export type TrackingDiagnosticIncidentListResponse = {
  items: TrackingDiagnosticIncident[]
  hasMore: boolean
}

export async function getTrackingDiagnosticIncidents(options: {
  status?: TrackingDiagnosticStatus
  search?: string
  limit?: number
} = {}) {
  const { data } = await apiClient.get<TrackingDiagnosticIncidentListResponse>(
    '/api/admin/tracking-diagnostics',
    { params: options }
  )
  return data
}

export async function getOpenTrackingDiagnosticCount() {
  const { data } = await apiClient.get<{ openCount: number }>(
    '/api/admin/tracking-diagnostics/count'
  )
  return data.openCount
}

export async function updateTrackingDiagnosticStatus(
  incidentId: string,
  status: TrackingDiagnosticStatus
) {
  const { data } = await apiClient.patch<TrackingDiagnosticIncident>(
    `/api/admin/tracking-diagnostics/${encodeURIComponent(incidentId)}/status`,
    { status }
  )
  return data
}
